import type { TSliceReducer } from 'core/store';
import { initialState } from './constants';
import type { IModuleNavigationState } from './types';

export const clearModuleNavigationState: TSliceReducer<IModuleNavigationState> = state => {
  Object.assign(state, initialState);
};

export const reducers = { clearModuleNavigationState };
